import React from 'react';

function Israel(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124100)">
        <mask
          id="mask0_800_124100"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124100)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#F7FCFF"
          />
          <mask
            id="mask1_800_124100"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124100)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 3V6H36V3H0Z"
              fill="#3D58DB"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 18V21H36V18H0Z"
              fill="#3D58DB"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.8037 14.9388H23.3528L18.1303 6.6203L12.8037 14.9388ZM21.5472 13.9295H14.6479L18.1197 8.45995L21.5472 13.9295Z"
              fill="#3D58DB"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.6719 9.07606H23.2658L18.1527 17.1615L12.6719 9.07606ZM21.4259 10.05H14.6823L18.1228 15.5312L21.4259 10.05Z"
              fill="#3D58DB"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124100">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Israel;
